import React, { Component, createRef } from "react";
import "./index.css";
import _ from "lodash";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import { ReactSortable } from "react-sortablejs";
import { createTooltip } from "../../../utils/createTooltip";
import { BsyUtils } from "../../../utils/Utils";

class BsyDashboardMyFavorites extends Component {
  static defaultProps = {
    favorites: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      favorites: props.favorites,
      apps: props.apps,
      itemWidth: 200,
      items: [],
    };
    this.element = createRef();
  }

  getItems = (favorites) => {
    return favorites.map((item) => {
      return {
        ...item,
        context: this.renderComponent(item),
      };
    });
  };

  componentWillUnmount() {
    this.hideTooltip();
  }

  componentDidMount = () => {
    // 获取上下文
    this.props.getContext?.(this);
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
    // 计算合适的宽度
    const calculateWidth = () => {
      const element = this.element.current;
      if (!element) return 200; // 默认宽度

      const containerWidth = element.clientWidth - 40; // 容器宽度减去内边距
      const minItemWidth = 200; // 最小宽度
      const gap = 6; // 间隔

      // 计算可容纳的列数
      const col = Math.floor(containerWidth / (minItemWidth + gap));

      // 根据列数计算每列宽度
      const colWidth = Math.floor(containerWidth / col) - gap;

      return Math.max(colWidth, minItemWidth);
    };

    // 设置宽度并获取收藏列表
    this.setState(
      {
        itemWidth: calculateWidth(),
      },
      this.favoritesList
    );
  };

  favoritesList = (cb) => {
    React.axios("/dashboard/favorites", {}).then((res) => {
      const { data: resData } = res;
      this.setState(
        {
          favorites: resData.favorites,
          items: this.getItems(resData.favorites),
        },
        () => {
          this.props?.onRefreshChars?.(resData.favorites);
        }
      );
    });
  };

  onItemsChange = (items) => {
    if (!_.isEqual(items, this.state.items)) {
      this.setState(
        {
          items: [...items],
        },
        () => {
          this?.props?.updateFavorites(items, false);
        }
      );
    }
  };

  favorite = (data) => {

    // 直接更新状态，不等后端返回
    if (data.type === "app") {
      const newApps = this.state.apps.map((item) => {
        return {
          ...item,
          apps: item.apps.map((res) => {
            if (res._id === data.value.appId) {
              return {
                ...res,
                isFavorite: false,
              };
            }
            return res;
          }),
        };
      });
      this.props?.onUpdataApps(newApps);
    }
    const newFavorites = this.state.favorites.filter(
      (item) =>
        item.value.entryId !== data.value.entryId ||
        item.value.appId !== data.value.appId
    );
    this.setState({
      favorites: newFavorites,
      items: this.getItems(newFavorites),
    });
    this.hideTooltip();
    React.axios("/dashboard/favorite_remove", {
      favorites: [
        data.type === "app"
          ? {
            type: "app",
            appId: data.value.appId,
          }
          : {
            type: "entry",
            appId: data.value.appId,
            entryId: data.value.entryId,
          },
      ],
    }).then((res) => {
      const { data: resData } = res;
      if (resData.code === 200) {
        this.props?.onUpdataApps(null, true);
      } else if (resData.code === 400) {
        tipAlert({
          type: "error",
          msg: resData.msg || React.language("error.201"),
        });
      }
    });
  };

  toTarget = (component) => {
    if (component.type === "app") {
      window.location.href = `${window.rootDirectroy}/team/app/${component.value.appId}`;
    } else {
      window.location.href = `${window.rootDirectroy}/team/app/${component.value.appId}/${component.value.type}/${component.value.entryId}`;
    }
  };

  renderComponent = (component) => {
    const { itemWidth } = this.state;
    if (!component) {
      return "";
    }
    if (component.isValid === false) {
      return (
        <div
          className="favorite-item fail"
          key={`favorite-item-${component.value.appId}-${component.value.entryId}`}
          style={{ width: "180px" }}
        >
          <div className="favorite-item-left">
            <i className={`node-icon icon-bsy-help`}></i>
            <span className="fail-text">
              {React.language("app.favorites.fail")}
            </span>
          </div>
          <i
            className="icon-bsy-favorite"
            data-for="favoriteTip"
            data-tip={React.language("app.favorites.cancel")}
            onClick={(e) => {
              e.stopPropagation();
              this.favorite(component);
            }}
          ></i>
        </div>
      );
    }
    if (component.type === "app") {
      return (
        <div
          className="favorite-item"
          key={`favorite-item-${component.value.appId} }`}
          style={{ width: "180px" }}
        >
          <div
            className="favorite-item-left"
            onClick={() => {
              this.toTarget(component);
            }}
          >
            <div
              className={"app-icon color-cover-" + component.value.style.color}
            >
              <div
                className={
                  "imgbg-bsy-app imgbg-bsy-app-" + component.value.style.icon
                }
              />
            </div>
            <span>{component.value.appname}</span>
          </div>

          <i
            className="icon-bsy-favorite"
            data-for="favoriteTip"
            data-tip={React.language("app.favorites.cancel")}
            onClick={(e) => {
              e.stopPropagation();
              this.favorite(component);
            }}
            onMouseEnter={(e) => {
              this.showTooltip(
                e.currentTarget,
                React.language("app.favorites.cancel"),
                "bottom",
                10
              );
            }}
            onMouseLeave={() => {
              this.hideTooltip();
            }}
          ></i>
        </div>
      );
    }
    return (
      <div
        className="favorite-item"
        key={`favorite-item-${component.value.appId}-${component.value.entryId}`}
        style={{ width: "180px" }}
      >
        <div
          className="favorite-item-left"
          onClick={() => {
            this.toTarget(component);
          }}
        >
          <i
            className={`node-icon icon-bsy-${component.value.type} ${component.value.icon > 24 ? `icon-new-bsy-form-${component.value.icon}` : `icon-bsy-form-${component.value.icon}`}`}
          ></i>
          <span>{component.value.name}</span>
        </div>

        <i
          className="icon-bsy-favorite"
          data-for="favoriteTip"
          data-tip={React.language("app.favorites.cancel")}
          onClick={(e) => {
            e.stopPropagation();
            this.favorite(component);
          }}
          onMouseEnter={(e) => {
            this.showTooltip(
              e.currentTarget,
              React.language("app.favorites.cancel"),
              "bottom",
              10
            );
          }}
          onMouseLeave={() => {
            this.hideTooltip();
          }}
        ></i>
      </div>
    );
  };

  render() {
    const { items } = this.state;
    return (
      <div className={"dashboard-my-favorites"} ref={this.element}>
        {BsyUtils.isObjectEmpty(items) && <div className="dash-empty">
          <span className="dash-empty-title">
            {React.language("dash.favorites.empty")}
          </span>
          <span className="dash-add-btn" onClick={this?.props?.onAddFavorites}>
            {React.language("add")}
          </span>
        </div>}
        <ReactSortable
          list={items}
          setList={this.onItemsChange}
          // style={{
          //   position: "relative",
          //   display: "flex",
          //   flexWrap: "wrap",
          //   width: "100%",
          // }}
          animati={150}
          ghostClass="sortable-ghost"
          chosenClass="sortable-chosen"
          dragClass="sortable-drag"
        // handle={".favorite-item"}
        // className={`column-content `}
        >
          {items.map((item, index) => {
            return item.context;
          })}
        </ReactSortable>
      </div>
    );
  }
}

export default BsyDashboardMyFavorites;
